/* Second Bloom — floating tab bar + shared Shop/Menu window (mobile only) */
(function () {
  if (customElements.get('sb-mobile-nav')) return;
  var MQ = window.matchMedia('(max-width: 749px)');

  function cartRoute() {
    return (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
  }
  function cartDrawer() {
    var d = document.getElementById('Cart-Drawer');
    return d && typeof d.open === 'function' ? d : null;
  }

  // Phones: keep the header in the page flow. The store's custom head script pins it on scroll;
  // marking it as already set up stops that script (it runs at DOMContentLoaded, after this deferred file).
  if (MQ.matches) {
    var hdr = document.querySelector('[class*="ai-custom-header-"]');
    if (hdr) hdr.__stickyInit = true;
  }

  // Tell listeners when any script changes the cart (quick add, drawer qty, product page).
  if (!window.__sbFetchPatched) {
    window.__sbFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var a = arguments[0];
        var url = typeof a === 'string' ? a : (a && a.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(url)) {
          p.then(function () { document.dispatchEvent(new CustomEvent('sb:cart-changed')); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  class SBMobileNav extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[data-sb-tabbar]');
      this.browse = this.querySelector('[data-sb-browse]');
      this.shopItem = this.querySelector('[data-sb-open="shop"]');
      this.cartBadge = this.querySelector('[data-sb-cart-count]');
      this.savedBadge = this.querySelector('[data-sb-saved-count]');
      this.compactOn = this.dataset.compact !== 'false';
      this.fallbackReveal = parseInt(this.dataset.reveal || '120', 10);
      this.isOpen = false;
      this.lastY = window.scrollY;
      this.ticking = false;
      document.documentElement.classList.add('sbn-nav-on');
      document.body && document.body.classList.add('sbn-nav-on');

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', () => { this.reveal = null; this.update(); }, { passive: true });

      this.addEventListener('click', (e) => this.onClick(e));
      document.addEventListener('click', (e) => this.onHeaderClick(e), true);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });

      var refresh = this.debounce(() => this.refreshCart(), 150);
      ['sb:cart-changed', 'cart:item-added', 'line-item:change:end', 'cart:refresh', 'cart:updated'].forEach(function (n) {
        document.addEventListener(n, refresh);
      });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });

      window.addEventListener('pageshow', (e) => {
        if (e.persisted) { this.close(true); this.refreshCart(); this.renderSaved(); }
      });
      document.addEventListener('sb:favourites-changed', () => this.renderSaved());
      window.addEventListener('storage', () => this.renderSaved());
      this.renderSaved();
      this.update();
    }

    debounce(fn, wait) {
      var t;
      return function () { clearTimeout(t); t = setTimeout(fn, wait); };
    }

    revealPoint() {
      if (this.reveal != null) return this.reveal;
      var header = document.querySelector('[class*="ai-custom-header-"]');
      var bottom = header ? header.getBoundingClientRect().bottom + window.scrollY : 0;
      this.reveal = Math.max(bottom, 40) || this.fallbackReveal;
      return this.reveal;
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => { this.ticking = false; this.update(); });
    }

    update() {
      if (!MQ.matches) return;
      var y = window.scrollY;
      var shown = this.isOpen || y > this.revealPoint();
      this.classList.toggle('is-shown', shown);
      if (this.compactOn && shown && !this.isOpen) {
        if (y > this.lastY + 2) this.classList.add('is-compact');
        else if (y < this.lastY - 2) this.classList.remove('is-compact');
        clearTimeout(this.idle);
        this.idle = setTimeout(() => this.classList.remove('is-compact'), 450);
      } else {
        this.classList.remove('is-compact');
      }
      this.lastY = y;
    }

    onClick(e) {
      var open = e.target.closest('[data-sb-open]');
      if (open) {
        e.preventDefault();
        if (this.isOpen && this.tab === open.dataset.sbOpen) this.close();
        else this.open(open.dataset.sbOpen);
        return;
      }
      if (e.target.closest('[data-sb-close]')) { e.preventDefault(); this.close(); return; }
      var tab = e.target.closest('[data-sb-tab]');
      if (tab) { e.preventDefault(); this.setTab(tab.dataset.sbTab); return; }
      var cart = e.target.closest('[data-sb-cart]');
      if (cart) {
        var d = cartDrawer();
        if (d) { e.preventDefault(); this.close(); d.open(); }
        return;
      }
      // Other links inside the window: keep the window up while the next page loads, so the old page
      // never flashes in between. It is reset on pageshow if the shopper comes back with the Back button.
    }

    onHeaderClick(e) {
      if (!MQ.matches) return;
      var trigger = e.target.closest('[class*="ai-mobile-menu-trigger-"]');
      if (trigger) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.open('menu');
        return;
      }
      var headerCart = e.target.closest('[class*="ai-header-cart-wrapper-"] a');
      if (headerCart) {
        var d = cartDrawer();
        if (d) { e.preventDefault(); e.stopImmediatePropagation(); d.open(); }
      }
    }

    setTab(name) {
      this.tab = name === 'menu' ? 'menu' : 'shop';
      this.querySelectorAll('[data-sb-tab]').forEach((b) => {
        var on = b.dataset.sbTab === this.tab;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      this.querySelectorAll('[data-sb-panel]').forEach((p) => { p.hidden = p.dataset.sbPanel !== this.tab; });
      if (this.shopItem) this.shopItem.classList.toggle('is-active', this.isOpen && this.tab === 'shop');
      var scroller = this.browse && this.browse.querySelector('.sbn-browse__scroll');
      if (scroller) scroller.scrollTop = 0;
    }

    open(tab) {
      if (!this.browse) return;
      this.lastFocus = document.activeElement;
      this.isOpen = true;
      this.browse.hidden = false;
      this.setTab(tab);
      document.documentElement.classList.add('sbn-lock');
      requestAnimationFrame(() => this.browse.classList.add('is-open'));
      this.classList.add('is-browsing');
      this.update();
      var close = this.browse.querySelector('[data-sb-close]');
      if (close) close.focus({ preventScroll: true });
    }

    close(instant) {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.browse.classList.remove('is-open');
      document.documentElement.classList.remove('sbn-lock');
      this.classList.remove('is-browsing');
      if (this.shopItem) this.shopItem.classList.remove('is-active');
      var hide = () => { if (!this.isOpen) this.browse.hidden = true; };
      if (instant) hide(); else setTimeout(hide, 260);
      if (this.lastFocus && this.lastFocus.focus && !instant) this.lastFocus.focus({ preventScroll: true });
      this.update();
    }

    refreshCart() {
      if (!this.cartBadge) return;
      fetch(cartRoute() + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then((c) => {
          var n = c && typeof c.item_count === 'number' ? c.item_count : 0;
          this.cartBadge.textContent = n;
          this.cartBadge.hidden = n === 0;
          var cartItem = this.querySelector('[data-sb-cart]');
          if (cartItem) cartItem.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
        })
        .catch(function () {});
    }

    renderSaved() {
      if (!this.savedBadge) return;
      var n = window.SBFav ? window.SBFav.count() : 0;
      this.savedBadge.textContent = n;
      this.savedBadge.hidden = n === 0;
    }
  }

  customElements.define('sb-mobile-nav', SBMobileNav);
})();
